import { combineEpics } from 'redux-observable';

import { findInvoiceEpic }             from './FindInvoice/FindInvoiceEpic';
import { findInvoicesEpic }            from './FindInvoices/FindInvoicesEpic';
import { updateInvoiceEpic }           from './UpdateInvoice/UpdateInvoiceEpic';
import { sendInvoicePdfEpic }          from './SendInvoicePdf/SendInvoicePdfEpic';
import { sendTicketsFromInvoiceEpic }  from './SendTicketsFromInvoice/SendTicketsFromInvoiceEpic';
import { downloadInvoicePdfEpic }      from './DownloadInvoicePdf/DownloadInvoicePdfEpic';
import { downloadTicketsFromInvoiceEpic } from './DownloadTicketsFromInvoice/DownloadTicketsFromInvoiceEpic';


export const invoiceEpics = combineEpics(
  findInvoiceEpic,
  findInvoicesEpic,
  updateInvoiceEpic,
  sendInvoicePdfEpic,
  sendTicketsFromInvoiceEpic,
  downloadInvoicePdfEpic,
  downloadTicketsFromInvoiceEpic,
);
